import React from "react";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import LookupItemAdmin from "../Contents/Administration/Lookup/LookupItem/LookupItemAdmin";
import TabListTableCellWidthEnum from "../Enums/TabListTableCellWidthEnum";
import LogComponent from "../Elements/LogComponent";

export default class LookupItem {
  constructor(item) {
    if (item === undefined) {
      this.LookupId = "";
      this.Name = ";";
    } else {
      this.LookupId = item.lookupId;
      this.Name = item.name;
    }
  }

  static NameOfTheIdField() {
    return "Name";
  }

  static nameOfTheItemDetailList() {
    return "Lookups";
  }

  static MoneyFields = [];

  static Currency() {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return "";
  }

  static DateFields = [];
  static BoolFields = [];

  static FieldsToShowInListTable = [
    { tabName: "Lookup Items", tabLabel: "Lookup Items", icon: "fa-solid fa-stream", data: [{ name: LookupItem.getLookupItemContent, label: "Lookup Items", width: TabListTableCellWidthEnum.Table }] },
    { tabName: "Log", tabLabel: "Log", icon: "fa-solid fa-stream", data: [{ name: LookupItem.getLogContent, label: "Log", width: TabListTableCellWidthEnum.TwoLines }] },
  ];

  static getLogContent(item) {
    return <LogComponent entityType="LookupItem" entityId={item.LookupId} />;
  }

  static getLookupItemContent(item) {
    return (
      <div>
        <LookupItemAdmin LookupItemId={item.LookupId} />
      </div>
    );
  }

  static FieldsToShowInDataTable() {
    return [
      { label: "Id", orderById: "Id", data: "LookupId", type: FieldTypesEnum.DataFieldWithDetails, minWidth: 80 },
      { label: "Name", orderById: "Name", data: "Name" },
      { label: " ", orderById: "", data: "", minWidth: "700px" },
    ];
  }
}
